import React from 'react';
import { Code } from 'components/ui/code';
import { MobileHeaderCell } from './mobile-header-cell';

export const CodeCell = ({ code, cell }: { code: string; cell: any }) => {
  return (
    <MobileHeaderCell header={cell.headerLabel}>
      <Code code={code} />
    </MobileHeaderCell>
  );
};
